import 'slick-carousel';
export function indexFunc() {
    var $slider;
     $slider = $('#slideshowWrap ul');
    $slider.slick({
        autoplay: true,
        autoplaySpeed: 3000,
        arrows:false,
        fade:true,
        default:1,
        speed: 2000,
        swipe: false,
        dots: true,
        dotsClass: 'slide-dots',
        pauseOnHover:false,
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/js/pages/_index.js
// module id = 13
// module chunks = 0